import { FileText, Download } from 'lucide-react';
import type { Attachment } from '../types/models';

interface Props {
  attachments: Attachment[];
}

function formatSize(bytes: number) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function handleDownload(attachment: Attachment) {
  const a = document.createElement('a');
  a.href = attachment.downloadUrl;
  a.download = attachment.fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export default function MeetingAttachments({ attachments }: Props) {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {attachments.map(att => (
        <button
          key={att.id}
          onClick={() => handleDownload(att)}
          className="flex items-center gap-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 hover:border-gray-300 transition-colors group"
        >
          <FileText className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <div className="text-left min-w-0">
            <p className="text-sm font-medium text-gray-700 truncate max-w-[200px]">{att.fileName}</p>
            <p className="text-xs text-gray-400">{formatSize(att.fileSize)}</p>
          </div>
          <Download className="w-3.5 h-3.5 text-gray-300 group-hover:text-teal-600 transition-colors flex-shrink-0" />
        </button>
      ))}
    </div>
  );
}
